import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "data-table-td"
};
const _hoisted_8 = {
  class: "font-mono text-xs"
};
const _hoisted_9 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "data-table-td"
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = {
  class: "text-xs text-slate-500"
};
const _hoisted_14 = {
  class: "data-table-td is-right"
};
const _hoisted_15 = {
  class: "data-table-td text-xs"
};
const _hoisted_16 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_19 = {
  class: "grid grid-cols-1 gap-4 rounded-lg border border-slate-200 p-4 md:grid-cols-4"
};
const _hoisted_20 = {
  class: "rounded-lg border border-slate-200"
};
const _hoisted_21 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_22 = {
  class: "data-table-scroll"
};
const _hoisted_23 = {
  class: "data-table text-sm"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  class: "data-table-td"
};
const _hoisted_26 = {
  class: "data-table-td is-right"
};
const _hoisted_27 = {
  class: "data-table-td is-right"
};
import { onMounted, reactive, ref } from 'vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { getWealthFundLedgerBatchDetails, getWealthFundLedgerPage } from '@/api/wealth';
import WealthDetailDrawer from '../components/WealthDetailDrawer.vue';
import WealthStatusBadge from '../components/WealthStatusBadge.vue';
import { cleanPayload, directionOptions, formatDateTime, formatMoney, operationTypeOptions, PAGE_SIZE_OPTIONS, pagePayload, syncPageResult } from '../utils';
export default {
  __name: 'index',
  setup(__props) {
    const filters = reactive({
      ledgerNo: '',
      operationType: '',
      direction: '',
      wealthCustomerId: null,
      contractId: null
    });
    const pagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const rows = ref([]);
    const loading = ref(false);
    const detailVisible = ref(false);
    const selectedLedger = ref(null);
    const details = ref([]);
    async function loadLedgers() {
      loading.value = true;
      try {
        const result = await getWealthFundLedgerPage(pagePayload(pagination, cleanPayload(filters)));
        rows.value = result?.records || [];
        syncPageResult(pagination, result);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      pagination.page = 1;
      loadLedgers();
    }
    function handleReset() {
      Object.assign(filters, {
        ledgerNo: '',
        operationType: '',
        direction: '',
        wealthCustomerId: null,
        contractId: null
      });
      handleSearch();
    }
    function handlePageChange(page) {
      pagination.current = page;
      pagination.page = page;
      loadLedgers();
    }
    function handleSizeChange(size) {
      pagination.size = size;
      handleSearch();
    }
    async function openDetail(row) {
      selectedLedger.value = row;
      detailVisible.value = true;
      details.value = await getWealthFundLedgerBatchDetails(row.id);
    }
    onMounted(loadLedgers);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal mx-6 pt-6"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "资金流水"), _createElementVNode("p", {
          class: "list-page-description"
        }, "查看不可修改的财富资金流水和多批次明细。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: loadLedgers
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.ledgerNo = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入流水编号"
          }, null, 512), [[_vModelText, filters.ledgerNo]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.wealthCustomerId = $event),
            type: "number",
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入客户ID"
          }, null, 512), [[_vModelText, filters.wealthCustomerId, void 0, {
            number: true
          }]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.contractId = $event),
            type: "number",
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入合同ID"
          }, null, 512), [[_vModelText, filters.contractId, void 0, {
            number: true
          }]]), _createVNode(_component_el_select, {
            modelValue: filters.operationType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.operationType = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operationTypeOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.direction,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filters.direction = $event),
            placeholder: "请选择方向",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部方向",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(directionOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[10] || (_cache[10] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "流水"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "方向"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "客户/合同/批次"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "金额"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "账户本金前后"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[7] || (_cache[7] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "加载中...", -1)]))])) : rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [...(_cache[8] || (_cache[8] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "暂无流水", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(rows.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(row.ledgerNo), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(row.accountingSerialNo), 1)]), _createElementVNode("td", _hoisted_10, [_createVNode(WealthStatusBadge, {
            type: "operation",
            value: row.operationType
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_11, [_createVNode(WealthStatusBadge, {
            type: "direction",
            value: row.direction
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_12, [_createElementVNode("div", null, "客户 " + _toDisplayString(row.wealthCustomerId || '-'), 1), _createElementVNode("div", _hoisted_13, "合同 " + _toDisplayString(row.contractId || '-') + " / 批次 " + _toDisplayString(row.batchId || '-'), 1)]), _createElementVNode("td", {
            class: _normalizeClass(["data-table-td is-right money-text", row.direction === 'OUT' ? 'text-red-600' : 'text-emerald-600'])
          }, _toDisplayString(row.direction === 'OUT' ? '-' : '+') + "¥" + _toDisplayString(_unref(formatMoney)(row.amount)), 3), _createElementVNode("td", _hoisted_14, "¥" + _toDisplayString(_unref(formatMoney)(row.beforeAccountPrincipal)) + " → ¥" + _toDisplayString(_unref(formatMoney)(row.afterAccountPrincipal)), 1), _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatDateTime)(row.createTime)), 1), _createElementVNode("td", _hoisted_16, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "明细",
            "aria-label": "明细",
            onClick: $event => openDetail(row)
          }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 12h16M4 18h16"
          })], -1)]))], 8, _hoisted_17)])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": _unref(PAGE_SIZE_OPTIONS),
          onPageChange: handlePageChange,
          onSizeChange: handleSizeChange
        }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)]), _createVNode(WealthDetailDrawer, {
          modelValue: detailVisible.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => detailVisible.value = $event),
          title: "流水详情",
          subtitle: selectedLedger.value?.ledgerNo
        }, {
          default: _withCtx(() => [selectedLedger.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("section", _hoisted_19, [_createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "操作类型", -1)), _createVNode(WealthStatusBadge, {
            type: "operation",
            value: selectedLedger.value.operationType
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "方向", -1)), _createVNode(WealthStatusBadge, {
            type: "direction",
            value: selectedLedger.value.direction
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "金额", -1)), _createElementVNode("div", {
            class: _normalizeClass(["money-text", selectedLedger.value.direction === 'OUT' ? 'text-red-600' : 'text-emerald-600'])
          }, _toDisplayString(selectedLedger.value.direction === 'OUT' ? '-' : '+') + "¥" + _toDisplayString(_unref(formatMoney)(selectedLedger.value.amount)), 3)]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "备注", -1)), _createElementVNode("div", null, _toDisplayString(selectedLedger.value.remark || '-'), 1)])]), _createElementVNode("section", _hoisted_20, [_cache[17] || (_cache[17] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-4 py-3"
          }, [_createElementVNode("h4", {
            class: "text-sm font-semibold"
          }, "批次明细")], -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("table", _hoisted_23, [_cache[16] || (_cache[16] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "批次ID"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "批次本金前后")])], -1)), _createElementVNode("tbody", null, [details.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [...(_cache[15] || (_cache[15] = [_createElementVNode("td", {
            colspan: "3",
            class: "data-table-empty"
          }, "暂无明细", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(details.value, item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_25, _toDisplayString(item.batchId), 1), _createElementVNode("td", _hoisted_26, "¥" + _toDisplayString(_unref(formatMoney)(item.amount)), 1), _createElementVNode("td", _hoisted_27, "¥" + _toDisplayString(_unref(formatMoney)(item.beforeBatchPrincipal)) + " → ¥" + _toDisplayString(_unref(formatMoney)(item.afterBatchPrincipal)), 1)]);
          }), 128))])])])])])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue", "subtitle"])]),
        _: 1
      });
    };
  }
};